import CellRangeDecorator from './slick.cellrangedecorator';
export default CellRangeDecorator;
